import useTranslate from 'modules/local/useTranslate'
import React, {useMemo, useState} from 'react'
import {NullAsDefault} from 'views/Shared'
import {notifyOnError} from "../../factory/createErrorEvent";
import {bindQueryParam} from "../../functions/routerHelper";
import {
    yellowPage_createNewYellowPage_Api,
    yellowPage_deleteYellowPage_Api,
    yellowPage_editYellowPage_Api
} from "../../../../apis";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import CRUD from "../../../Shared/enums/CRUD";
import {DelayRender} from "../../../Shared/components/DelayRender";
import YellowPageContext, {YellowPageProvider} from "../YellowPageContext";
import {YellowPageDetailViewForm} from "../components/YellowPageForm";
import LoadingBlock from "../../../Loading/LoadingBlock";
import {DrawDialog} from "../../../../components/drawer/dialog/DrawDialog";

const hiddenTrigger = <span style={{display: 'none'}}/>


export const useYellowPage = ({
                                  notifyListeners = {
                                      onCreated: undefined,
                                      onUpdated: undefined,
                                      onDeleted: undefined,
                                  },
                              }) => {
    const t = useTranslate()
    const [action, setAction] = useState({type: undefined, value: undefined})

    const {
        onCreated = NullAsDefault,
        onUpdated = NullAsDefault,
        onDeleted = NullAsDefault,
    } = notifyListeners ?? {}

    const onError = notifyOnError(t)

    const {handleAsyncAction: onCreate, ...asyncCreating} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: yellowPage_createNewYellowPage_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.CREATE, t)
            onCreated(result, data)
        },
    })

    const {handleAsyncAction: onUpdate, ...asyncUpdating} = useAsyncAction({
        onError,
        apiInfo: yellowPage_editYellowPage_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onUpdated(result, data)
        },
    })

    const {handleAsyncAction: onDelete, ...asyncDeleting} = useAsyncAction({
        onError,
        apiInfo: yellowPage_deleteYellowPage_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.DELETE, t)
            onDeleted(result, data)
        },
    })

    const handleAction = (action, params) => {
        switch (action) {
            case CRUD.READ:
                setAction({type: action, value: params})
                break
            default:
                break
        }
    }
    const onCancel = () => {
        setAction({})
    }
    const showDetailModal = (params) => {
        return handleAction(CRUD.READ, params)
    }

    const detailModal = useMemo(() => {
        let Content = NullAsDefault
        let Wrapper = ({children}) => children({initialValues: {}})
        let params = {initValues: {...action.value}}
        let modal_params = {}
        switch (action.type) {
            case CRUD.READ:
                params = {}
                modal_params = {
                    width: 600,
                    title: (
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('yellow page information')}
                        </div>
                    ),
                }
                Content = ({...rest}) => (
                    <YellowPageProvider item={action.value}>
                        <YellowPageContext.Consumer>
                            {({item}) => {
                                return (
                                    <YellowPageDetailViewForm
                                        {...rest}
                                        item={item}
                                        reportAccess={false}
                                    />
                                )
                            }}
                        </YellowPageContext.Consumer>
                    </YellowPageProvider>
                )
                break
            default:
                break
        }

        if (!action.type || action.type === CRUD.DELETE) return null

        return (
            <DrawDialog
                width={600}
                visible={true}
                footer={false}
                component={hiddenTrigger}
                onCancel={onCancel}
                {...modal_params}>
                {(isToggle) => isToggle && (
                    <DelayRender lazy={true}>
                        <Wrapper>
                            {({isLoading, initialValues}) => {
                                if (!!isLoading) {
                                    return <LoadingBlock/>
                                }
                                return (
                                    <Content
                                        {...{
                                            onCancel,
                                            item: action.value,
                                        }}
                                        {...params}
                                        initialValues={initialValues}
                                    />
                                )
                            }}
                        </Wrapper>
                    </DelayRender>
                )}
            </DrawDialog>
        )
    }, [action])

    return {
        onCreate,
        onUpdate,
        onDelete,
        asyncCreating,
        asyncUpdating,
        asyncDeleting,
        detailModal,
        showDetailModal
    }
}



